<template>
  <div>
    <v-text-field
      v-model="formData.kv"
      label="KV"
      outlined
      clearable
      dense
      autofocus
      @keydown.enter="fetchRekap"
    ></v-text-field>

    <h3>Preview</h3>
    <p v-if="state.noData">No Data</p>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading ...
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <main
      class="report"
      v-if="!state.noData && !state.loading"
      id="section-print"
    >
      <div class="header">
        <div class="left">
          <h2 class="report-title">REKAP NOTA PER KAPAL</h2>
          <h3 class="text-center">
            {{ data.vessel.nama_kapal }} - {{ data.vessel.id }}
          </h3>
        </div>
        <div class="right ml-5">
          <table>
            <tr>
              <td>Tanggal Berangkat</td>
              <td>:</td>
              <td class="border">
                {{ convertTanggal(data.vessel.tgl_berangkat) }}
              </td>
            </tr>
            <tr>
              <td>Voyage</td>
              <td>:</td>
              <td class="border-dotted">{{ data.vessel.voy }}</td>
            </tr>
          </table>
        </div>
      </div>

      <div class="mt-4">
        <table width="100%" class="table-border">
          <thead>
            <th>Jenis Nota</th>
            <th>Nomor Nota</th>
            <th>Ditagih Kepada</th>
            <th>Kubikasi</th>
            <th>Tonase</th>
            <!-- <th>Biaya Tambahan</th> -->
            <th>Nominal Nota</th>
          </thead>
          <tbody>
            <template v-for="type in data.data">
              <tr v-for="invoice in type" :key="invoice.id">
                <td>{{ invoice.kode_nota }}</td>
                <td>{{ invoice.nomor_nota }}</td>
                <td v-if="invoice.customer">{{ invoice.customer.nama }}</td>
                <td v-else>-</td>
                <td>{{ totalKubikasi(invoice.invoice_detil) }}</td>
                <td>{{ totalTonase(invoice.invoice_detil) }}</td>
                <!-- <td>{{ formatCurrency(invoice.biaya_lain_total) }}</td> -->
                <td>
                  {{
                    formatCurrency(
                      Math.abs(invoice.i_total) +
                        Math.abs(invoice.ii_total) +
                        Math.abs(invoice.biaya_lain_total)
                    )
                  }}
                </td>
              </tr>
              <tr :key="type.id">
                <td colspan="3"></td>
                <td>{{ subtotalKubikasi(type) }}</td>
                <td>{{ subtotalTonase(type) }}</td>
                <td>{{ subtotalInvoice(type) }}</td>
              </tr>
            </template>
            <tr class="no-border">
              <td colspan="5" class="text-right">Total :</td>
              <td>{{ totalInvoice(data) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      v-if="!state.noData && !state.loading && data.vessel"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      state: {
        loading: false,
        noData: true
      },
      formData: {
        kv: ""
      },
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  watch: {
    "formData.kv"(val) {
      if (val) {
        this.formData.kv = val.toUpperCase();
      }
    }
  },
  computed: {
    today() {
      let date = new Date();
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    async fetchRekap() {
      this.state.loading = true;

      await axios
        .get(`invoice/rekap-nota?kv=${this.formData.kv}`)
        .then(res => {
          if (res.data.length == 0) {
            this.state.noData = true;
          } else {
            this.data = res.data;
            this.state.noData = false;
          }
          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    },
    totalKubikasi(data) {
      let total = 0;

      data.forEach(invoice => {
        invoice.ttb.ttb_rinci.forEach(rinci => {
          total += rinci.m3;
        });
      });

      return total.toFixed(2);
    },
    totalTonase(data) {
      let total = 0;

      data.forEach(invoice => {
        invoice.ttb.ttb_rinci.forEach(rinci => {
          total += rinci.ton;
        });
      });

      return total.toFixed(2);
    },
    subtotalKubikasi(data) {
      let total = 0;

      data.forEach(invoice => {
        total += parseFloat(this.totalKubikasi(invoice.invoice_detil));
      });

      return total.toFixed(2);
    },
    subtotalTonase(data) {
      let total = 0;

      data.forEach(invoice => {
        total += parseFloat(this.totalTonase(invoice.invoice_detil));
      });

      return total.toFixed(2);
    },
    subtotalInvoice(data) {
      let total = 0;

      data.forEach(invoice => {
        total +=
          Math.abs(invoice.i_total) +
          Math.abs(invoice.ii_total) +
          Math.abs(invoice.biaya_lain_total);
      });

      return this.formatCurrency(total);
    },
    totalInvoice(data) {
      let total = 0;

      for (let i in data.data) {
        for (let j in data.data[i]) {
          total +=
            Math.abs(data.data[i][j].i_total) +
            Math.abs(data.data[i][j].ii_total) +
            Math.abs(data.data[i][j].biaya_lain_total);
        }
      }

      return this.formatCurrency(total);
    },
    convertTanggal(data) {
      let date = new Date(data);
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${date.getDate()} ${this.months[month]} ${year}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    }
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.header {
  display: flex;
}

.left .report-title {
  text-decoration: underline;
}

.right {
  font-style: italic;
  font-weight: bold;
  font-size: 1.1rem;
}

.table-border th {
  text-align: left;
  text-transform: uppercase;
}

.table-border,
.table-border th,
.table-border td {
  border: 2px solid black;
  border-collapse: collapse;
}

.table-border td {
  padding: 0 2px;
}

tr.no-border td {
  border: none;
}
</style>
